import React, { useState } from 'react';
import NoValue from '../EmptyStates/NoValue';
import Loading from '../Loading';
import { useAssets } from '../../Data/Assets';
import Gallery from './Gallery';

const Preview = ({assetIds, empty}) => {
    const {assets, isLoading} = useAssets(assetIds);
    const [isOpen, setIsOpen] = useState(false);

    if (!assetIds || assetIds.length === 0) {
        return empty ?? <NoValue />;
    }

    if (isLoading) {
        return <Loading />;
    }

    const open = (assetId) => {
        // Skip to index?
        setIsOpen(assetId);
    }

    return <>
        <div className="flex flex-row gap-2">
            {assets.map(asset => <Thumbnail key={asset.id} {...{open, asset}} />)}
        </div>
        <Gallery {...{isOpen: !!isOpen, setIsOpen, assetIds, initialAssetId: isOpen}} />
    </>;
}

const Thumbnail = ({asset, open}) => {
    return <div className="w-24 h-24 border p-1 rounded-md overflow-hidden hover:border-brand cursor-pointer">
        <img src={asset.thumbnail}
            alt={asset.name}
            className="w-full h-full object-cover rounded-md"
            onClick={() => open(asset.id)}
        />
    </div>;
}

export default Preview;
